import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/common/Sidebar';
import { Navbar } from '@/components/common/Navbar';

/**
 * Admin console shell.
 * Phase 2 mounts user management, payout approvals, media manager, settings inside <Outlet />.
 */
export function AdminLayout() {
  return (
    <div className="glow-field flex min-h-svh">
      <Sidebar variant="admin" />
      <div className="flex flex-1 flex-col">
        <Navbar variant="app" appNav="admin" />
        <main className="flex-1 p-6 lg:p-10">
          <div className="mx-auto w-full max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
